const Teacher = () => import('@/views/main/fubo/Teacher/Teacher.vue')
export default {
  path: '/main/fubo/teacher',
  name: 'Teacher',
  component: Teacher,
  children: []
}
